<template>
  <div class="box-tooltip" :style="positionTooltip" :class="showTooltip">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'tooltip',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    positionTooltip() {
      return {
        top: `${this.data.y}px`,
        left: `${this.data.x}px`,
      };
    },
    showTooltip() {
      return {
        visible: this.data.visible,
      };
    },
  },
  methods: {},
};
</script>

<style scoped>
.box-tooltip {
  border-radius: 4px !important;
  position: absolute;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 15px;
  z-index: 50;
  margin: 0 auto;
  color: white;
  display: none;
  transform: translate(-10%, -50%);
}
.box-tooltip.visible {
  display: block;
}
</style>
